import React, { Component } from 'react'
import { Card, Button} from 'react-bootstrap'

import { connect } from 'react-redux'
import { createPost } from '../../../../../store/actions/RichMessageActions'

import logoimage from './News.png'


import { withTranslation } from 'react-i18next'

class SignalNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: Date.now().toString(),
      category: this.props.categories?.find(ct => ct?.content?.toLowerCase().trim() === "signal")?.id ?? this.props.category?.id,
      color: '#CCFBFF',
      title: 'NEWS',
      table: [
        {position: 0, title: 'Indicator', detail: 'Non-farm Payroll'},
        {position: 1, title: 'Previous', detail: ''},
        {position: 2, title: 'Forecast', detail: ''},
        {position: 3, title: 'Actual', detail: ''}
      ],
      media: null,
      comment: 'Today US Non-farm payroll figures came above expectations. Stock market rises.',
    };
  }

  insertTemplate = () => {
    this.props.createPost(this.state)
  }

  render() {
    
    const { t } = this.props

    return (
      <Card className="rrich-message__signals__card">
        <div className="rrich-message__signals__card__wrapper d-flex justify-content-between">
          <div className="rrich-message__signals__card__img">
            <img src={logoimage} alt=""/>
          </div>
          <div className="rrich-message__signals__card__aside">
            <div className="rrich-message__signals__card__aside__title">{t("signal_text_12")}</div>
            <div className="rrich-message__signals__card__aside__price">{t("signal_text_13")}</div>
            <div className="rrich-message__signals__card__aside__btn">
              <Button size="xs" variant="outline-success" onClick={this.insertTemplate}>{t("signal_text_14")}</Button>
            </div>
          </div>
        </div>
      </Card>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createPost: (post) => dispatch(createPost(post)),
  }
}

export default withTranslation()(connect(null, mapDispatchToProps)(SignalNews))
